import {
  AudienceTemplateWcaLookalikesQuery,
  AudienceTemplateWcaLookalikesQueryVariables
} from './__generated__/AudienceTemplateWcaLookalikesQuery';
import { useLazyQuery } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { AUDIENCE_TEMPLATE_WCA_LOOKALIKES_QUERY } from './audienceTemplateWcaLookalikes.query';

export const useAudienceTemplateWcaLookalikesQuery = () => {
  return useLazyQuery<AudienceTemplateWcaLookalikesQuery, AudienceTemplateWcaLookalikesQueryVariables>(
    AUDIENCE_TEMPLATE_WCA_LOOKALIKES_QUERY,
    {
      client: kmsClient,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    }
  );
};
